import { SettingCard } from './SettingCard'
import { withSettingCard } from './withSettingCard'

const ConnectedSettingCard = withSettingCard(SettingCard)
export { ConnectedSettingCard as SettingCard }
